/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { agentConnectorsListAgentConnectors } from "../../funcs/agentConnectorsListAgentConnectors.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListAgentConnectorsRequest$inboundSchema,
};

export const tool$agentConnectorsListAgentConnectors: ToolDefinition<
  typeof args
> = {
  name: "agent-connectors-list-agent-connectors",
  description: `List connectors for an agent

Lists messaging-channel connectors configured for the agent. Connector credentials are never returned.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await agentConnectorsListAgentConnectors(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
